import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { StorageService, STORAGE_KEYS } from './storage.service';
import { environment } from '../../environments/environment';

/** Reads tenantId from route (e.g. /:tenantId/wip). Same idea as AIO auth.interceptor. */
function getTenantIdFromRoute(router: Router): string {
  let route: ActivatedRouteSnapshot | null = router.routerState.snapshot.root;
  while (route) {
    const tenantId = route.paramMap.get('tenantId');
    if (tenantId) return tenantId;
    route = route.firstChild ?? null;
  }
  return '';
}

function isAuthExcludedUrl(url: string): boolean {
  /** Logout uses explicit headers in AuthService.logout (before storage clear). */
  const paths = [
    environment.loginUrl,
    environment.logoutUrl,
    environment.mfaVerifyUrl,
    environment.mfaResendUrl,
  ];
  return paths.some(p => url.includes(p));
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (isAuthExcludedUrl(req.url)) {
    return next(req);
  }

  const storage = inject(StorageService);
  const router = inject(Router);

  const token = storage.getItem<string>(STORAGE_KEYS.LOGIN_TOKEN);
  let tenantId = getTenantIdFromRoute(router);
  if (!tenantId) {
    tenantId = storage.getItem<string>(STORAGE_KEYS.TENANT_ID) ?? '';
  }

  if (!token) {
    return next(req);
  }

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };
  if (tenantId) {
    headers['x-tenant-id'] = tenantId;
  }

  return next(req.clone({ setHeaders: headers }));
};
